import request from './request'

export const adCreateLogApi = {
    getBatches(params) {
        return request({
            url: '/api/ad-create-logs/batches',
            method: 'get',
            withCredentials: false,
            params: {
                page: params.page || 1,
                pageSize: params.pageSize || 20
            }
        })
    },

    getBatchItems(batchId, params = {}) {
        return request({
            url: `/api/ad-create-logs/batches/${batchId}/items`,
            method: 'get',
            withCredentials: false,
            params: {
                page: params.page || 1,
                pageSize: params.pageSize || 100
            }
        })
    }
}
